import { STATUS_BAR_HANDLE } from "./actionTypes";

export const setStatusBarClose = (type, btn_close) => ({
  type: STATUS_BAR_HANDLE,
  payload: { type, btn_close },
});
